/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_2_PInputs */

const en_privacy_2_p = /** @type {(inputs: Privacy_2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To run the service: generate documents, plan work, sync with your agent and show your history. To bill you and prevent abuse (quota, rate limits, fraud checks). To improve Bystep, using aggregated and anonymised usage statistics. To answer support requests. We do not sell your data and we do not use your content to train models.`)
};

const id_privacy_2_p = /** @type {(inputs: Privacy_2_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjalankan layanan: membuat dokumen, menyusun rencana, sinkronisasi dengan agen, dan menampilkan riwayatmu. Menagih dan mencegah penyalahgunaan (kuota, pembatasan laju, pemeriksaan fraud). Memperbaiki Bystep lewat statistik penggunaan agregat dan anonim. Menjawab permintaan dukungan. Kami tidak menjual datamu dan tidak memakai kontenmu untuk melatih model.`)
};

/**
* | output |
* | --- |
* | "To run the service: generate documents, plan work, sync with your agent and show your history. To bill you and prevent abuse (quota, rate limits, fraud check..." |
*
* @param {Privacy_2_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_2_p = /** @type {((inputs?: Privacy_2_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_2_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_2_p(inputs)
	return en_privacy_2_p(inputs)
});